import { render, staticRenderFns } from "./AdminCopperHost.vue?vue&type=template&id=d1388508&scoped=true&"
import script from "./AdminCopperHost.vue?vue&type=script&lang=js&"
export * from "./AdminCopperHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1388508",
  null
  
)

export default component.exports